import { render, staticRenderFns } from "./gift_send.vue?vue&type=template&id=2eb83254&scoped=true"
import script from "./gift_send.vue?vue&type=script&lang=ts"
export * from "./gift_send.vue?vue&type=script&lang=ts"
import style0 from "./gift_send.vue?vue&type=style&index=0&id=2eb83254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb83254",
  null
  
)

export default component.exports